// extracted by mini-css-extract-plugin
export default {"bulkbar":"BulkBar_bulkbar__lE58y","close":"BulkBar_close__YnYRC"};